<template>
  <app-page-container :showNav="true">
    <div class="lord-container">
      <div v-if="user._id === '60e9bb09b27e5d0015d73a2f' || user._id == '5ffa95888d24191c09f7f0bb' || user._id == '60c559f4c0f06216f42042bc'" class="lord-center">
        <img src="https://ik.imagekit.io/elysiumone/Badges/Badges__12__JbPuf-GP00.png" class="crown-size" />
        <div class="lord-center">
          <input v-model="userToAwardID" placeholder="Worthy user's ID" class="worthyid" />
          <div class="awardMedal" @click="awardMedal">Award them a Medal</div>
          <div class="removeMedal" @click="removeMedal">Remove their Medal</div>
          <span class="awardStatus">{{ awardingStatus }}</span>
        </div>
      </div>
      <div v-else>
        You have not arrived at the heights of the Lord of The Medals! 🏅
      </div>
    </div>
  </app-page-container>
</template>

<script>
import { mapState } from "vuex";
import AppPageContainer from "@/components/AppPageContainer";
import magicAPI from "../../api/magicAPI";

export default {
  name: "LordOfTheMedal",
  data() {
    return {
      userToAwardID: "",

      awardingStatus: "",
    };
  },
  components: {
    AppPageContainer,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    async awardMedal() {
      if (this.userToAwardID === "60e9bb09b27e5d0015d73a2f") {
        return (this.awardingStatus = "The Lord of Medals already controls all the medals!");
      }
      this.awardingStatus = "Awarding the Medal...";
      this.excludingInProcess = true;
      const response = await magicAPI.awardMedal(this.userToAwardID);
      console.log("the response: ", response);
      if (response === false) {
        this.awardingStatus = "You need to provide the worthy user's ID.";
      } else if (response.error) {
        this.awardingStatus = response.error;
      } else if (response.success && !response.error) {
        this.awardingStatus = "Medal has been successfully awarded!";
      } else if (!response.success && !response.error) {
        this.awardingStatus = "Something went extra wrong.";
      }
    },
    async removeMedal() {
      if (this.userToAwardID === "60e9bb09b27e5d0015d73a2f") {
        return (this.awardingStatus = "The Lord of Medals has too many medals to ever rid himself of them!");
      }
      this.awardingStatus = "Removing the Medal...";
      const response = await magicAPI.removeMedal(this.userToAwardID);
      console.log("the response: ", response);
      if (response === false) {
        this.awardingStatus = "You need to provide the unworthy user's ID.";
      } else if (response.error) {
        this.awardingStatus = response.error;
      } else if (response.success && !response.error) {
        this.awardingStatus = "Medal has been removed from the unworthy!";
      } else if (!response.success && !response.error) {
        this.awardingStatus = "Something went extra wrong.";
      }
    },
  },
};
</script>

<style scoped>
.lord-container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  background: url("https://images.unsplash.com/photo-1573667575521-68b5f991e069");
}
.worthyid {
  font-size: 20px;
  box-shadow: 0px 1px 4px 0 #afafaf57;
  border-radius: 360px;
  padding: 10px 20px;
  width: 335px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.lord-center {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.awardMedal,
.removeMedal {
  font-size: 20px;
  margin-top: 15px;
  letter-spacing: 0.5px;
  background-color: #111;
  color: white;
  padding: 14px 14px;
  font-weight: 600;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  width: 335px;
  margin: 5px 0px;
  font-family: "Nunito", sans-serif;
}
.removeMedal {
  background-color: darkred;
  color: white;
}
.awardMedal:hover {
  background-color: #444;
}
.removeMedal:hover {
  background-color: #a56767;
}
.crown-size {
  width: 300px;
  height: 300px;
  margin-top: -150px;
}
.awardStatus {
  font-size: 18px;
  margin-top: 15px;
}
</style>
